import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useQuery } from "@tanstack/react-query";
import { VoucherType } from "../types/VoucherType";

export const GET_VOUCHER_TYPES_FETCH_KEY = "GET_VOUCHER_TYPES_FETCH_KEY";

export const getVoucherTypes = async (
  zoneIds?: string[] | string | null,
): Promise<VoucherType[]> => {
  const response = await fetcher.get(`${API.GESLUB}/voucher-type`, {
    params: {
      zoneIds,
    },
  });
  return response.data;
};

export const useGetVoucherTypes = (zoneIds?: string[] | string | null) => {
  const {
    data = [],
    error,
    isLoading,
    isFetching,
  } = useQuery<VoucherType[]>({
    queryKey: [GET_VOUCHER_TYPES_FETCH_KEY, zoneIds],
    queryFn: () => getVoucherTypes(zoneIds),
  });

  const isPending = isLoading || isFetching;

  return {
    data,
    error,
    isPending,
  };
};
